import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';
import classNames from 'classnames';
import { FC } from 'react';

import classes from './LabelCheckbox.module.scss';

export interface LabelCheckboxProps {
  color:
    | 'info'
    | 'error'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'default';
  label?: string;
  className?: string;
  CheckboxProps?: CheckboxProps;
}

const LabelCheckbox: FC<LabelCheckboxProps> = ({
  color,
  label,
  className,
  CheckboxProps,
}) => {
  return (
    <FormControlLabel
      className={classNames(classes.Checkbox, className)}
      control={<Checkbox {...CheckboxProps} disableRipple color={color} />}
      label={label}
    />
  );
};

export default LabelCheckbox;
